import { Tag, type TableColumnType } from 'antd';
import type { ProdutoLocalEstoque } from '@/features/produto-local-estoque/types/ProdutoLocalEstoque';
import type { ProdutoBodyLote } from '@/features/produto/types/ProdutoBody';
import { getButtonsEditDelete } from '@/components/table/table-actions/TableActionsEditDelete';
import { TableActionsInline } from '@/components/table/table-actions/TableActionsInline';
import { ProdutoLoteStatus } from '@/features/produto/types/ProdutoLote';

const statusLabel: Record<ProdutoLoteStatus, string> = {
    [ProdutoLoteStatus.Ativo]: 'Ativo',
    [ProdutoLoteStatus.Encerrado]: 'Encerrado / Esgotado',
    [ProdutoLoteStatus.Expirado]: 'Expirado / Vencido',
};

export function produtoTabEstoqueLoteTableColumns({
    locais,
    onDelete,
    onEdit,
}: {
    locais: ProdutoLocalEstoque[];
    onDelete: (row: ProdutoBodyLote) => void;
    onEdit: (row: ProdutoBodyLote) => void;
}): TableColumnType<ProdutoBodyLote>[] {
    return [
        { dataIndex: 'prl_chave', title: 'Código do lote' },
        { dataIndex: 'prl_localizacao', title: 'Localização' },
        {
            align: 'center',
            dataIndex: 'prl_status',
            render: (status: ProdutoLoteStatus) => statusLabel[status] ?? '',
            title: 'Situação',
        },
        {
            align: 'center',
            dataIndex: 'prl_data_fabricacao',
            title: 'Data de fabricação',
        },
        {
            align: 'center',
            dataIndex: 'prl_data_vencimento',
            title: 'Data de vencimento',
        },
        {
            dataIndex: 'estoque',
            render: (estoques: ProdutoBodyLote['estoque']) => (
                <div className='flex flex-wrap gap-1'>
                    {(estoques ?? []).map((estoque) => {
                        const local = locais.find(
                            (item) => item.est_idpk === estoque.ple_estoque_idpk,
                        );

                        return (
                            <Tag
                                className='m-0 text-base'
                                color='blue'
                                key={estoque.ple_estoque_idpk}
                            >
                                {local?.est_descricao ?? `Local ${estoque.ple_estoque_idpk}`}:&nbsp;
                                <b>{estoque.ple_estoque_atual ?? '-'}</b>
                            </Tag>
                        );
                    })}
                </div>
            ),
            title: 'Estoque por local',
        },
        {
            align: 'center',
            key: 'acoes',
            render: (_, row) => (
                <TableActionsInline
                    buttons={getButtonsEditDelete({
                        disabled: false,
                        onDelete: () => onDelete(row),
                        onEdit: () => onEdit(row),
                    })}
                />
            ),
            title: 'Ações',
        },
    ];
}
